namespace $.$$ {

	export class $shm_dashboard_app_dashboard_list_head extends $.$shm_dashboard_app_dashboard_list_head {

		controls() {
			return this.search_showed() ? [ this.Filter() ] : []
		}

	}

}
